import * as React from 'react';
import Griddle, { RowDefinition, ColumnDefinition, GriddlePageProperties, plugins } from 'griddle-react';
import * as GridConfig from '../../config/grid-config-simple';
import './DataGrid.css';


interface DataSimpleGridProps {
    entities: any[];
    columns: { id: string, title?: string, width?: string, customComponent?: ({ value }: any) => JSX.Element }[];
    pageSize?: number;
}

export class DataGridSimple extends React.Component<DataSimpleGridProps> {
    private pageProperties: GriddlePageProperties = {
        currentPage: 1,
        pageSize: 20,
    };
    
    constructor(props: DataSimpleGridProps) {
        super(props);

        if (this.props.pageSize) {
            this.pageProperties.pageSize = this.props.pageSize;
        }
    }

    public render() {
        const { entities, columns } = this.props;

        return (
            <Griddle data={entities} plugins={[plugins.LocalPlugin]} styleConfig={GridConfig.gridStyle} pageProperties={this.pageProperties} components={{ Layout: GridConfig.gridSimpleLayout }}>
                <RowDefinition>
                    {columns.map((column, index) => <ColumnDefinition key={`column-${index}`} {...column} />)}
                </RowDefinition>
            </Griddle>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/datagrid/DataGridSimple.tsx